import React, { useState, useEffect } from "react";
// import MUIDataTable from "mui-datatables";
import { Bar, Line, Pie, Doughnut } from "react-chartjs-2";
import useFetch from "../services/employeeService";
import * as employeeService from "../services/employeeService";
import PageHeader from "../components/PageHeader";
import InfoBox from "../components/InfoBox";
import FarmerCard from "../components/FarmerCard";
import PeopleOutlineTwoToneIcon from "@material-ui/icons/PeopleOutlineTwoTone";
import {
  Paper,
  makeStyles,
  withStyles,
  // CircularProgress,
  // Typography,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from "@material-ui/core";
import { tableCellClasses } from "@material-ui/core/Table";
import { styled } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Controls from "../components/controls/Controls";
import useTable from "../components/useTable";
import Modal from "../components/Popup";
import { useHistory } from "react-router-dom";
import Loading from "../components/Loading";
import DashboardIcon from "@material-ui/icons/Dashboard";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import DateRangeIcon from "@material-ui/icons/DateRange";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import ApartmentIcon from "@material-ui/icons/Apartment";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import "../App/App.css";
let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
});

L.Marker.prototype.options.icon = DefaultIcon;

const useStyles = makeStyles((theme) => ({
  pageContent: {
    margin: theme.spacing(3),
    padding: theme.spacing(3),
    [theme.breakpoints.down("xs")]: {
      margin: "0px",
      marginBottom: "15px",
      padding: theme.spacing(2),
    },
  },
  searchInput: {
    width: "75%",
  },
  newButton: {
    float: "right",
    marginTop: "14px",
    marginRight: "14px",
  },
  pageBox: {
    margin: theme.spacing(1),
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1),
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

export default function Deposit(props) {
  const classes = useStyles();
  // const [count, setCount] = useState(0)
  const [{ data: crops }] = useFetch("get", "/crop", null);
  const [popupData, setPopupData] = useState({});
  const [popupCropData, setPopupCropData] = useState([]);
  const [markerPopupImage, setMarkerPopupImage] = useState(null);
  const [openFarmerPopup, setOpenFarmerPopup] = useState(false);
  const [openCropPopup, setOpenCropPopup] = useState(false);
  const [value, setValue] = useState(crops[0].name ? crops[0].name : null);
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const date = new Date();
  const [start, setStart] = useState(
    new Date(date.getFullYear(), date.getMonth(), 1)
  );
  const [end, setEnd] = useState(new Date());
  const [params, setParams] = useState({
    offset: 0,
    limit: rowsPerPage,
    start: start,
    end: new Date().toISOString(),
    cropId: 1,
    // district: "Ampara",
    // grouping: "worker",
    // siteId: "229d83b6-9972-4b1c-91cf-d2290ba41099",
  });
  const { handleSearch, handleDateChange } = useTable(
    setParams,
    params,
    setStart,
    setEnd,
    rowsPerPage
  );

  const history = useHistory();

  const [
    { data: mapData = null, isLoading, count, error, summary },
    fetchData,
    fetchOtherData,
  ] = useFetch("get", "/harvest", params);

  const openFarmerDetailsPopup = async (data) => {
    let res = await fetchOtherData(
      "get",
      `/image?key=${data.farmer.farmlandPhoto}`,
      null
    );
    const farmerData = {};
    farmerData.farmlandPhoto = res.data.imageData;
    res = await fetchOtherData(
      "get",
      `/image?key=${data.farmer.profilePhoto}`,
      null
    );
    farmerData.profilePhoto = res.data.imageData;
    farmerData.farmer = data.farmer;
    setPopupData(farmerData);
    setOpenFarmerPopup(true);
  };

  const openCropsPopup = async (data) => {
    const cropData = mapData.filter(
      (mapdata) => mapdata.farmerId === data.farmerId
    );
    setPopupCropData(cropData);
    setOpenCropPopup(true);
  };

  const onClose = () => {
    setOpenCropPopup(false);
    setOpenFarmerPopup(false);
  };

  const getImage = async (imagePath) => {
    const res = await fetchOtherData("get", `/image?key=${imagePath}`, null);
    setMarkerPopupImage(res.data.imageData);
  };
  useEffect(() => {
    // console.log(`rowsPerPage changed to ${rowsPerPage}`);
    handleSearch(null, rowsPerPage, "select-option", "limit");
  }, [rowsPerPage]);
  // useEffect(() => {
  //   // console.log(error);
  //   if (error === "Request failed with status code 401") {
  //     history.push("/login");
  //   }
  // }, [error]);

  return (
    <>
      <PageHeader
        title="Home"
        subTitle="Farmer data analytics"
        icon={<DashboardIcon fontSize="large" />}
      />
      <Paper className={classes.pageContent}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Controls.DatePicker
              name="start"
              label="Start Date"
              value={start}
              onChange={handleDateChange}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controls.DatePicker
              name="end"
              label="End Date"
              value={end}
              onChange={handleDateChange}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controls.AutoComplete
              id="cropId"
              label="Crop"
              options={crops}
              value={value ? value : crops[0]}
              getOptionLabel={(option) => option.name}
              onChange={(event, value, reason) => {
                setValue(value);
                handleSearch(event, value, reason, "cropId");
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controls.AutoComplete
              id="district"
              label="District"
              // value={employeeService.getDistrictsCollection()[0]}
              options={employeeService.getDistrictsCollection()}
              getOptionLabel={(option) => option.title}
              getOptionSelected={(option, value) =>
                option.title === value.title
              }
              onChange={(event, value, reason) =>
                handleSearch(event, value, reason, "district")
              }
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Controls.AutoComplete
              id="limit"
              label="Farmer Count"
              options={[
                { limit: "20" },
                { limit: "50" },
                { limit: "100" },
                { limit: "250" },
                { limit: "500" },
                { limit: "1000" },
              ]}
              getOptionLabel={(option) => option.limit}
              onChange={(event, value, reason) => {
                setRowsPerPage(+value?.limit || 20);
              }}
            />
          </Grid>
        </Grid>
      </Paper>
      <Modal
        title="Crop Details"
        openPopup={openCropPopup}
        fullWidth={false}
        setOpenPopup={setOpenCropPopup}
        onClose={onClose}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>Crop</StyledTableCell>
                <StyledTableCell align="right">
                  Land Extent in Acres
                </StyledTableCell>
                <StyledTableCell align="right">
                  Expected Harvest in kg
                </StyledTableCell>
                <StyledTableCell align="right">Month</StyledTableCell>
                <StyledTableCell align="right">Year</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {popupCropData.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell component="th" scope="row">
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.landExtent}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {row.expectedHarvest}
                  </StyledTableCell>
                  <StyledTableCell align="right">{row.month}</StyledTableCell>
                  <StyledTableCell align="right">{row.year}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Modal>
      {openFarmerPopup && (
        <Modal
          title="Farmer Details"
          openPopup={openFarmerPopup}
          fullWidth={false}
          setOpenPopup={setOpenFarmerPopup}
          onClose={onClose}
        >
          <Grid container columnSpacing={{ md: 1, lg: 2 }}>
            <Grid item xs={12} md={6}>
              {popupData.farmlandPhoto && (
                <img
                  src={popupData.farmlandPhoto}
                  width="250px"
                  height="250px"
                  alt="Profile"
                  style={{ margin: "5px", marginBottom: "0px" }}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              {popupData.profilePhoto && (
                <img
                  src={popupData.profilePhoto}
                  width="250px"
                  height="250px"
                  alt="Profile"
                  style={{ margin: "5px", marginBottom: "0px" }}
                />
              )}
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <List dense={true}>
                <ListItem>
                  <ListItemText
                    primary="Farmer name"
                    secondary={`${popupData.farmer.firstName} ${popupData.farmer.lastName}`}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Address"
                    secondary={popupData.farmer.address}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Phone"
                    secondary={popupData.farmer.phone}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="District"
                    secondary={popupData.farmer.district}
                  />
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} md={6}>
              <List dense={true}>
                <ListItem>
                  <ListItemText
                    primary="D S Division"
                    secondary={popupData.farmer.dsDivision}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Gender"
                    secondary={popupData.farmer.gender}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Organic"
                    secondary={popupData.farmer.isOrganic ? "yes" : "no"}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Non Organic"
                    secondary={popupData.farmer.isNonOrganic ? "yes" : "no"}
                  />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Modal>
      )}

      <MapContainer
        center={[7.291418, 80.636696]}
        zoom={8}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {mapData[0] &&
          mapData[0].farmer &&
          mapData.map((data) => (
            <Marker
              // onClick={() => {
              //   getImage(data.farmer.farmlandPhoto);
              //   console.log("markerPopupImage", markerPopupImage);
              // }}
              eventHandlers={{
                click: (e) => {
                  // console.log("marker clicked", e);
                  getImage(data.farmer.farmlandPhoto);
                  // console.log("markerPopupImage", markerPopupImage);
                },
              }}
              position={[
                data.farmer.coordinates.coordinates[1],
                data.farmer.coordinates.coordinates[0],
              ]}
              key={data.id}
            >
              <Popup className="">
                {markerPopupImage && (
                  <FarmerCard
                    farmlandPhoto={markerPopupImage}
                    farmerName={`${data.farmer.firstName} ${data.farmer.lastName}`}
                    // landExtent={data.landExtent}
                    // expectedHarvest={data.expectedHarvest}
                    address={data.farmer.address}
                    openFarmerDetailsPopup={() => {
                      openFarmerDetailsPopup(data);
                    }}
                    openCropsPopup={() => {
                      openCropsPopup(data);
                    }}
                  ></FarmerCard>
                )}
              </Popup>
            </Marker>
          ))}
      </MapContainer>

      {/* {summary && (
        <Paper className={classes.pageContent}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <InfoBox
                title="Total Farmers"
                subTitle={2454}
                icon={<PeopleOutlineTwoToneIcon fontSize="large" />}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InfoBox
                title="Total Locations"
                subTitle={38}
                icon={<AccessTimeIcon fontSize="large" />}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InfoBox
                title="Total Days"
                subTitle={345}
                icon={<DateRangeIcon fontSize="large" />}
              />
            </Grid>

            <Grid item xs={12} md={6} lg={3}>
              <InfoBox
                title="Total Cost"
                subTitle={`85 500 LKR`}
                icon={<LocalAtmIcon fontSize="large" />}
              />
            </Grid>
          </Grid>
        </Paper>
      )} */}
      <div>
        <Grid
          container
          spacing={1}
          justifycontent="center"
          direction="row"
          style={{ margin: "0 auto" }}
        >
          {/* <Grid item xs={12} lg={8}>
          <Paper
            className={classes.pageBox}
            square
            style={{ paddingLeft: "20px" }}
          >
            <Bar
              style={{ paddingTop: "10px", paddingRight: "10px" }}
              data={{
                labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
                datasets: [
                  {
                    label: "# of Votes",
                    data: [12, 19, 3, 5, 2, 3],
                    backgroundColor: [
                      "rgba(255, 99, 132, 0.2)",
                      "rgba(54, 162, 235, 0.2)",
                      "rgba(255, 206, 86, 0.2)",
                      "rgba(75, 192, 192, 0.2)",
                      "rgba(153, 102, 255, 0.2)",
                      "rgba(255, 159, 64, 0.2)",
                    ],
                    borderColor: [
                      "rgba(255, 99, 132, 1)",
                      "rgba(54, 162, 235, 1)",
                      "rgba(255, 206, 86, 1)",
                      "rgba(75, 192, 192, 1)",
                      "rgba(153, 102, 255, 1)",
                      "rgba(255, 159, 64, 1)",
                    ],
                    borderWidth: 1,
                  },
                ],
              }}
              options={{
                tooltips: {
                  mode: "index",
                  callbacks: {
                    label: function (toolTipItem) {
                      return "Revenue: $" + toolTipItem.value;
                    },
                  },
                },
                responsive: true,
                plugins: {
                  legend: {
                    position: "top",
                    // maxHeight: 100,
                    // maxWidth: 50,
                  },
                  title: {
                    display: true,
                    position: "bottom",
                    text: "Bar Chart",
                    font: { size: 16, family: "Times" },
                  },
                },
                scales: {
                  x: {
                    display: true,
                    title: {
                      display: true,
                      text: "Month",
                      color: "#911",
                      font: {
                        family: "Times",
                        size: 14,
                        style: "normal",
                        lineHeight: 1.2,
                      },
                      padding: { top: 8, left: 0, right: 0, bottom: 0 },
                    },
                    // gridLines: {
                    //   color: "cyan",
                    // },
                    // ticks: {
                    //   beginAtZero: true,
                    //   fontColor: "green",
                    // },
                  },
                  y: {
                    display: true,
                    title: {
                      display: true,
                      text: "Value",
                      color: "#911",
                      font: {
                        family: "Times",
                        size: 14,
                        style: "normal",
                        lineHeight: 1.2,
                      },
                      padding: { top: 30, left: 0, right: 0, bottom: 0 },
                    },
                  },
                },
              }}
            ></Bar>
          </Paper>
        </Grid> */}
          {mapData[0] && mapData[0].name && (
            <Grid item xs={12}>
              <Paper
                className={classes.pageBox}
                square
                // style={{ padding: "10px" }}
              >
                <Bar
                  style={{ paddingTop: "10px", paddingRight: "10px" }}
                  data={{
                    labels: mapData[0].graphData.map((data) => data.MonthYear),
                    datasets: [
                      {
                        label: "Harvest",
                        data: mapData[0].graphData.map(
                          (data) => data.totalExpectedHarvest
                        ),
                        backgroundColor: "rgb(54, 162, 235)",
                        borderWidth: 1,
                        borderRadius: 5,
                        borderSkipped: false,
                        barThickness: 28,
                      },
                      {
                        label: "Land Extent",
                        data: mapData[0].graphData.map(
                          (data) => data.landExtent
                        ),
                        backgroundColor: "rgb(255, 99, 132)",
                        borderWidth: 1,
                        borderRadius: 5,
                        borderSkipped: false,
                        barThickness: 28,
                      },
                      // {
                      //   label: "Store 3",
                      //   data: [123, 200, 232, 400, 232, 23],
                      //   backgroundColor: "rgb(75, 192, 192)",
                      //   borderWidth: 2,
                      //   borderRadius: 5,
                      //   borderSkipped: false,
                      //   barThickness: 24,
                      // },
                    ],
                  }}
                  options={{
                    tooltips: {
                      mode: "index",
                      callbacks: {
                        label: function (toolTipItem) {
                          return "Revenue: $" + toolTipItem.value;
                        },
                      },
                    },
                    responsive: true,
                    plugins: {
                      legend: {
                        position: "top",
                        // maxHeight: 100,
                        // maxWidth: 50,
                      },
                      title: {
                        display: true,
                        position: "bottom",
                        text: `Expected Harvest for ${mapData[0].name}`,
                        font: { size: 16, family: "Roboto" },
                      },
                    },
                    scales: {
                      x: {
                        display: true,
                        title: {
                          display: true,
                          text: "Year/Month",
                          color: "#292929",
                          font: {
                            family: "Roboto",
                            size: 14,
                            style: "normal",
                            lineHeight: 1.2,
                          },
                          padding: { top: 8, left: 0, right: 0, bottom: 0 },
                        },
                        // gridLines: {
                        //   color: "cyan",
                        // },
                        // ticks: {
                        //   beginAtZero: true,
                        //   fontColor: "green",
                        // },
                      },
                      y: {
                        display: true,
                        title: {
                          display: true,
                          text: "Harvest(kg) / Land Extent(acres)",
                          color: "#292929",
                          font: {
                            family: "Roboto",
                            size: 14,
                            style: "normal",
                            lineHeight: 1.2,
                          },
                          padding: { top: 30, left: 0, right: 0, bottom: 0 },
                        },
                      },
                    },
                  }}
                ></Bar>
              </Paper>
            </Grid>
          )}
        </Grid>
      </div>
      <Loading isLoading={isLoading} />
    </>
  );
}
